// Copyright 2026 Bitech.id. Licensed under the MIT License.

import type { BiwaveClient } from '@biwave/core';

export function setBrowserContext(client: BiwaveClient): void {
  client.setContext('browser', {
    user_agent: navigator.userAgent,
    language: navigator.language,
    languages: navigator.languages ? [...navigator.languages] : undefined,
    platform: navigator.platform,
    cookie_enabled: navigator.cookieEnabled,
    online: navigator.onLine,
  });
}

export function setPageContext(client: BiwaveClient): void {
  client.setContext('page', {
    url: window.location.href,
    title: document.title || undefined,
    referrer: document.referrer || undefined,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
  });
}

export function setDeviceContext(client: BiwaveClient): void {
  client.setContext('device', {
    screen_resolution: `${window.screen.width}x${window.screen.height}`,
    pixel_ratio: window.devicePixelRatio,
    color_depth: window.screen.colorDepth,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
}
